$(document).ready(function () {
  var $wrapper = $('[data-newsletter-form]');
  var $modalbackdrop = $('#modalbackdrop');
  var $closeBtn = $('[data-newsletter-form-close]');
  var $openBtn = $('[data-newsletter-form-open]')
  var $submitButtonReatil = $('[data-newsletter-form-submit-retail]');
  var $submitButtonCommercial = $('[data-newsletter-form-submit-commercial]');
  var $dataNewsletterFormContent = $('[data-newsletter-form-content]');
  var $dataNewsletterFormContentSubmitted = $('[data-newsletter-form-content-sumitted]');
  var $dataNewsletterFormSubmission = $('[data-newsletter-form-submission]');

  $dataNewsletterFormContent.css('display', 'block');
  $dataNewsletterFormContentSubmitted.css('display', 'none');

  var submit = function (e, type) {
    var $form = $('[data-newsletter-form]');
    var identityFieldsToTrack = [
      {
        selector: "[name=\"contact[Email]\"]",
        klaviyoFieldName: "$email"
      },
      {
        selector: "[name=\"contact[First Name]\"]",
        klaviyoFieldName: "$first_name"
      },
      {
        selector: "[name=\"contact[Last Name]\"]",
        klaviyoFieldName: "$last_name"
      },
      {
        selector: "[name=\"contact[State]\"]",
        klaviyoFieldName: "$region"
      }
    ];

    var identityKeyValue = {};
    identityFieldsToTrack.forEach(function (identityField) {
      var $element = $form.find(identityField.selector);
      var elementValue = $element.val();
      identityKeyValue[identityField.klaviyoFieldName] = elementValue;
    });

    if (identityKeyValue.$first_name.length > 0 && identityKeyValue.$last_name.length > 0 && identityKeyValue.$region.length > 0) {
      identityKeyValue['$address1'] = '-';
      identityKeyValue['$address2'] = '-';
      identityKeyValue['$city'] = '-';

      identityKeyValue['$type'] = type;

      // Define Klaviyo Object
      var klaviyo = window.klaviyo || [];
      // Identify Profile
      klaviyo.push(["identify", identityKeyValue]);
      // TODO: is this still in use? consider push to metrics if yes

      window.dataLayer.push({
        event: 'Newsletter customise information'
      });

      $dataNewsletterFormContent.css('display', 'none');
      $dataNewsletterFormContentSubmitted.css('display', 'block');

      e.stopPropagation();
      e.preventDefault();

    }

  }

  if ($wrapper.length) {

    $closeBtn.on('click', function () {
      $wrapper.css('display', 'none');
      $wrapper.css('opacity', 0);
      $dataNewsletterFormContent.css('display', 'block');
      $dataNewsletterFormContentSubmitted.css('display', 'none');
      $modalbackdrop.css('display', 'none');
    });

    $openBtn.on('click', function () {
      $wrapper.css('display', 'block');
      $wrapper.css('opacity', 1);
      $modalbackdrop.css('display', 'block');
    });

    $submitButtonReatil.on('click', function (e) {
      submit(e, "Retail");
    });

    $submitButtonCommercial.on('click', function (e) {
      submit(e, "Commercial");
    });

  }

});